"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.array.find-index");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _moment = _interopRequireDefault(require("moment"));

var _elementUi = require("element-ui");

var _lastMileDeliveryPricerite = require("@/mixins/last-mile-delivery-pricerite/last-mile-delivery-pricerite");

var _transferOrderModal = _interopRequireDefault(require("../transfer-order-modal/transfer-order-modal.vue"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDGanttChartComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDGanttChartComponent, _Mixins);

  var _super = _createSuper(LMDGanttChartComponent);

  function LMDGanttChartComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDGanttChartComponent);
    _this = _super.apply(this, arguments);
    _this.truckWidth = 0;
    _this.locations = {};
    _this.isFilterTruck = false;
    _this.isShowEnabledTruck = false;
    _this.isTicking = false;
    _this.lastScrollLeft = 0;
    _this.timeList = [];
    _this.numOfDaysAdded = 1;
    _this.autoAddedDays = 1;
    _this.maxAutoAddedDays = 1;
    _this.timeStepper = 30;
    _this.currentTimeInterval = null;
    _this.currentTimeRefresh = 60; // seconds

    _this.currentTimeLeft = null;
    _this.leftWidth = 225;
    _this.smallLeftWidth = 100;
    _this.openMapModal = false;
    _this.isRealProcessingTime = false;
    _this.defaultProcessingTime = 15;
    return _this;
  }

  (0, _createClass2.default)(LMDGanttChartComponent, [{
    key: "onIsFilterTruckChanges",
    value: function onIsFilterTruckChanges(newVal) {
      this.$emit('onIsFilterTruckChanges', newVal);
    }
  }, {
    key: "onIsShowEnabledTruckChanges",
    value: function onIsShowEnabledTruckChanges(newVal) {
      this.$emit('onIsShowEnabledTruckChanges', newVal);
    }
  }, {
    key: "onInitAutoAddedDaysChanges",
    value: function onInitAutoAddedDaysChanges(newVal) {
      this.timeList = this.getTimeList(newVal);
    }
  }, {
    key: "onPlanDateChanges",
    value: function onPlanDateChanges(newVal) {
      this.timeList = this.getTimeList(this.numOfDaysAdded, newVal);
    }
  }, {
    key: "onTruckFiltersChanges",
    value: function onTruckFiltersChanges(newVal) {
      var index = newVal.findIndex(function (filter) {
        return filter.key === 'status';
      });

      if (newVal.length === 0 || index === -1) {
        this.isFilterTruck = false;
        this.isShowEnabledTruck = false;
        return;
      }

      this.isFilterTruck = true;
      this.isShowEnabledTruck = newVal[index]['value'] === 'Enabled Trucks';
    }
  }, {
    key: "onTimeStepperChanges",
    value: function onTimeStepperChanges(newVal) {
      var _this2 = this;

      this.timeStepper = newVal;
      this.timeList = this.getTimeList(this.numOfDaysAdded);
      this.$nextTick(function () {
        _this2.handleHorizontallyScrolling();

        _this2.getCurrentTimeLocation();
      });
    }
  }, {
    key: "onBooleanEnableTrucksChanges",
    value: function onBooleanEnableTrucksChanges(newVal) {
      return newVal ? this.enableAllTrucks() : this.disableAllTrucks();
    }
  }, {
    key: "onTrucksChanges",
    value: function onTrucksChanges(newVal) {
      var largestTruck = this.helper.maxBy(newVal, function (truck) {
        return truck.routes.length;
      });

      if (!this.helper.isUndefined(largestTruck) && largestTruck.routes && largestTruck.routes.length > 0) {
        var routesLen = largestTruck.routes.length;
        var lastRoute = largestTruck.routes[routesLen - 1];
        var end = (0, _moment.default)(lastRoute.endTime);
        var start = (0, _moment.default)(this.$planDate);
        var diff = end.diff(start, 'days'); // this.numOfDaysAdded = diff;

        if (diff >= 1) {
          this.maxAutoAddedDays = 0;
        }

        if (diff >= this.timeList.length) {
          this.timeList = this.getTimeList(this.numOfDaysAdded);
        }
      }
    }
  }, {
    key: "onTruckLoadingChanges",
    value: function onTruckLoadingChanges() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.handleHorizontallyScrolling();

        _this3.getCurrentTimeLocation();
        /*if (!this.helper.isUndefined(document.getElementById('ganttChart'))) {
          document.getElementById('ganttChart').addEventListener('scroll', this.handleGCEndScroll);
        }*/

      });
    }
  }, {
    key: "filteredTrucks",
    get: function get() {
      var _this4 = this;

      var start = (this.truckCurrentPage - 1) * this.truckPageSize;
      var end = this.truckCurrentPage * this.truckPageSize < this.$bufferTrucks.length ? this.truckCurrentPage * this.truckPageSize : this.$bufferTrucks.length;

      if (!this.isFilterTruck) {
        var filteredTrucks = this.$bufferTrucks.slice(start, end);
        this.disableTruckList = this.helper.uniq([].concat((0, _toConsumableArray2.default)(this.disableTruckList), (0, _toConsumableArray2.default)(filteredTrucks.filter(function (t) {
          return t['jobDate'].length === 0;
        }).map(function (t) {
          return t['id'];
        }))));
        localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
        return filteredTrucks;
      }

      var disabledTrucks = [];

      if (window.localStorage.getItem(this.disableTruckKey)) {
        disabledTrucks = window.localStorage.getItem(this.disableTruckKey).split(',');
      }

      var trucks = this.$bufferTrucks.filter(function (truck) {
        var bool = _this4.isValidTruck(truck) && !_this4.helper.includes(disabledTrucks, truck['id'].toString());
        var bool2 = !_this4.helper.includes(disabledTrucks, truck['id'].toString());
        return _this4.isAutoAssign ? _this4.isShowEnabledTruck ? bool : !bool : _this4.isShowEnabledTruck ? bool2 : !bool2;
      });
      end = this.truckCurrentPage * this.truckPageSize < trucks.length ? this.truckCurrentPage * this.truckPageSize : trucks.length;
      return trucks.slice(start, end);
    }
  }, {
    key: "gcContainerStyle",
    get: function get() {
      return {
        height: this.ganttChartHeight + 'px',
        top: 0
      };
    }
  }, {
    key: "gcHeaderStyle",
    get: function get() {
      return {
        width: this.truckWidth + 'px'
      };
    }
  }, {
    key: "isToday",
    get: function get() {
      return (0, _moment.default)(new Date()).format('YYYY-MM-DD') === this.$planDate;
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('scroll', this.handleGCEndScroll);

      if (this.currentTimeInterval) {
        clearInterval(this.currentTimeInterval);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.timeStepper = this.defaultTimeStepper; // this.timeList = this.getTimeList();

      this.timeList = this.getTimeList(this.numOfDaysAdded);

      if (window.localStorage.getItem(this.disableTruckKey)) {
        this.disableTruckList = window.localStorage.getItem(this.disableTruckKey).split(',');
      }

      this.isRealProcessingTime = this.$userSetting['default27'] || false;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this5 = this;

      this.autoAddedDays = this.initAutoAddedDays;
      this.currentTimeInterval = setInterval(function () {
        _this5.getCurrentTimeLocation();

        _this5.handleHorizontallyScrolling();
      }, this.currentTimeRefresh * 1000);
    }
    /**
     * 14 because of 30 minutes stepper, needs to change if the stepper changes;
     * this.$refs.ganttChart.scrollBy(216 + 14 * 54, 0);
     * */

  }, {
    key: "handleHorizontallyScrolling",
    value: function handleHorizontallyScrolling() {
      var el = this.helper.get(this.$refs, 'ganttChart', null);

      if (!el) {
        return false;
      }

      var start = (0, _moment.default)(new Date()).format('YYYY-MM-DD 00:00');
      var end = (0, _moment.default)(new Date());

      var duration = _moment.default.duration(end.diff(start, 'minutes'), 'minutes').asMinutes();

      var xAxis = duration * this.ganttChartCellWidth / this.timeStepper;
      var xPos = xAxis - el.clientWidth / 3;
      el.scrollTo(0, 0);
      el.scrollBy(xPos, 0);
    }
  }, {
    key: "hasData",
    value: function hasData(truckId) {
      return this.getRoutes(truckId).length >= 1;
    }
  }, {
    key: "openWindow",
    value: function openWindow(link) {
      window.open(link);
    }
  }, {
    key: "openMap",
    value: function openMap(truckId, truckName) {
      if (this.isTruckIdExistInGlobal(truckId) || !this.getRoutes(truckId).length) {
        return;
      }

      if (!this.isTruckClickable(truckId)) {
        return;
      }

      this.setTruck(truckId);
      this.openMapModal = true;
    }
  }, {
    key: "handleTransferModalClose",
    value: function handleTransferModalClose() {
      this.openMapModal = false;
    }
  }, {
    key: "setTruck",
    value: function setTruck(truckId) {
      if (this.$anyChanges && !this.isAutoAssign) {
        var message = {
          title: this.$i18n.t('planning.messages.saveBeforeSwitchTruck'),
          duration: 5000
        };

        _elementUi.Notification.warning(message);

        return false;
      }

      if (!(this.isClickable && !this.checkDisable(truckId) && !this.isTruckIdExistInGlobal(truckId) && (!this.$anyChanges || this.isAutoAssign))) {
        return false;
      }

      this.logger.info('setTruck', truckId);
      this.$setSelectedTruck(truckId); // Socket for global trucks

      this.socketAPI.updateLMDGlobalSelectedTrucks({
        userEmail: this.$userInformation.user.name,
        socketId: this.$socketId,
        truckId: truckId ? [truckId] : []
      });
      return true;
    }
  }, {
    key: "isTruckClickable",
    value: function isTruckClickable(truckId) {
      return !(this.$anyChanges && !this.isAutoAssign) && this.isClickable && !this.checkDisable(truckId) && !this.isTruckIdExistInGlobal(truckId) && (!this.$anyChanges || this.isAutoAssign);
    }
  }, {
    key: "hasRouteDetails",
    value: function hasRouteDetails(truckId) {
      var routeDistance = this.getRouteDetails(truckId)['estimatedDistance'];
      var routeTime = this.getRouteDetails(truckId)['estimatedTime'];
      return routeDistance || routeTime;
    }
  }, {
    key: "checkDisable",
    value: function checkDisable(truckId) {
      return !(!this.disableTruckList || this.disableTruckList.indexOf(truckId.toString()) === -1);
    }
  }, {
    key: "disableTruck",
    value: function disableTruck(truckId) {
      if (truckId) {
        this.disableTruckList = [].concat((0, _toConsumableArray2.default)(this.disableTruckList), [truckId.toString()]);
      }

      this.$setSelectedTruck(null);
      localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
    }
  }, {
    key: "enableTruck",
    value: function enableTruck(truckId) {
      if (truckId) {
        this.disableTruckList = this.disableTruckList.filter(function (i) {
          return i !== truckId.toString();
        });
      }

      localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
    }
  }, {
    key: "enableAllTrucks",
    value: function enableAllTrucks() {
      this.disableTruckList = [];
      localStorage.setItem(this.disableTruckKey, '');
      var truckHasNoJobDate = this.$trucks.filter(function (t) {
        return t['jobDate'].length === 0;
      });

      if (truckHasNoJobDate.length) {
        this.disableTruckList = truckHasNoJobDate.map(function (truck) {
          return truck['id'].toString();
        });
        localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
      }
    }
  }, {
    key: "disableAllTrucks",
    value: function disableAllTrucks() {
      this.disableTruckList = this.$trucks.map(function (truck) {
        return truck['id'].toString();
      });
      this.$setSelectedTruck(null);
      localStorage.setItem(this.disableTruckKey, this.disableTruckList.join(','));
    }
  }, {
    key: "handleGCEndScroll",
    value: function handleGCEndScroll() {
      var _this6 = this;

      var ganttChart = this.helper.get(this.$refs, 'ganttChart', null);

      if (ganttChart && !this.isTicking) {
        // Throttle the firing of the event
        window.requestAnimationFrame(function () {
          var documentScrollLeft = ganttChart.scrollLeft;

          if (_this6.lastScrollLeft !== documentScrollLeft) {
            if (ganttChart.scrollWidth - documentScrollLeft === ganttChart.clientWidth && _this6.autoAddedDays < _this6.maxAutoAddedDays) {
              // this.logger.info('End of scroll');
              _this6.numOfDaysAdded++;
              _this6.autoAddedDays++;
              _this6.timeList = _this6.getTimeList(_this6.numOfDaysAdded);
            }

            _this6.lastScrollLeft = documentScrollLeft;
          }

          _this6.isTicking = false;
        });
        this.isTicking = true;
      }
    }
  }, {
    key: "getTimeList",
    value: function getTimeList() {
      var daysOfIncrement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$planDate;
      var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$planDate;
      var stepper = this.timeStepper;
      var start = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.$planDate) : (0, _moment.default)(startDate);
      var eDate = this.helper.isUndefined(startDate) ? (0, _moment.default)(this.$planDate) : (0, _moment.default)(endDate);
      var end = daysOfIncrement === 0 ? (0, _moment.default)(eDate) : (0, _moment.default)(startDate).add(daysOfIncrement, 'days');

      var duration = _moment.default.duration(end.diff(start, 'days'), 'days').asDays();

      var endTime = (0, _moment.default)('00:00', 'HH:mm').subtract(stepper, 'm').format('HH:mm');
      var arr = [];
      var ctr = 0;

      for (var i = 0; i <= duration; i++) {
        var time = (0, _moment.default)('00:00', 'HH:mm');
        ctr = ctr + (i === 0 ? 0 : 1);
        var obj = {
          date: i === 0 ? start.format('YYYY-MM-DD') : start.add(1, 'days').format('YYYY-MM-DD'),
          timeList: [{
            time: time.format('HH:mm'),
            counter: ctr
          }]
        };

        while (time.format('HH:mm') !== endTime) {
          ctr++;
          time = time.add(stepper, 'm');
          obj['timeList'].push({
            time: time.format('HH:mm'),
            counter: ctr
          });
        }

        arr.push(obj);
      }

      var numOfDays = arr.length;

      if (arr[0] && arr[0]['timeList']) {
        this.truckWidth = numOfDays * arr[0]['timeList'].length * this.ganttChartCellWidth + (this.$isMobile ? this.smallLeftWidth : this.leftWidth);
      }

      return arr;
    }
  }, {
    key: "isShowCheckmark",
    value: function isShowCheckmark(truck) {
      if (this.isAutoAssign) {
        return this.isValidTruck(truck);
      }

      return true;
    }
  }, {
    key: "getContainerStyles",
    value: function getContainerStyles(route) {
      return {
        top: '6px',
        left: this.getContainerDimension(true, route) + 'px',
        width: this.getContainerDimension(false, route) + 'px',
        height: '20px'
      };
    }
  }, {
    key: "getContainerDimension",
    value: function getContainerDimension(isLeft) {
      var route = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var isMockTime = !this.isRealProcessingTime && route['status'].toUpperCase() === 'COMPLETED';
      var newRoute = this.helper.cloneDeep(route);
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.processingTime = isMockTime ? this.defaultProcessingTime : Number(newRoute.processingTime) / 60;
      var sTime = isMockTime ? (0, _moment.default)(newRoute.endTime).subtract(this.defaultProcessingTime + newRoute.time, 'minutes').format('YYYY-MM-DD HH:mm:ss') : newRoute.startTime;
      var start = this.helper.convertTimezone(sTime, this.$timezone);
      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDate) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDate), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }
      /**
       * old logic
       * assuming startTime + travellingTime (time) = eta (estimateTime)
       * */

      /*return multiplier * (
        isLeft ?
          duration :
          newRoute.time + newRoute.processingTime
      );*/
      // new logic


      var stTime = (0, _moment.default)(newRoute.startTime);
      var enTime = (0, _moment.default)(newRoute.endTime);

      var totalDuration = _moment.default.duration(enTime.diff(stTime)).asMinutes();

      return multiplier * (isLeft ? duration : totalDuration);
    }
  }, {
    key: "getRouteStyles",
    value: function getRouteStyles(route, dimensionType) {
      return {
        left: this.getLeftDimension(dimensionType, route) + 'px',
        width: this.getWidthDimension(dimensionType, route) + 'px',
        opacity: route['planId'] === this.currentPlanId ? 0.5 : 1
      };
    }
    /**
     * 30 minutes   = 54      <-- ganttChartCellWidth
     * 1 minute     = 1.8px   <-- 54/this.stepper
     * */

  }, {
    key: "getLeftDimension",
    value: function getLeftDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.processingTime = Number(newRoute.processingTime) / 60;

      if (timeType === 'travellingTime') {
        return 0;
      }

      if (timeType === 'processingTime') {
        /**
         * old logic
         * assuming startTime + travellingTime (time) = eta (estimateTime)
         * */
        // return multiplier * newRoute.time;
        // new logic
        var startTime = (0, _moment.default)(newRoute.startTime);
        var endTime = (0, _moment.default)(newRoute.estimateTime);

        var duration = _moment.default.duration(endTime.diff(startTime)).asMinutes();

        return multiplier * duration;
      }
    }
  }, {
    key: "getWidthDimension",
    value: function getWidthDimension(timeType, route) {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var newRoute = this.helper.cloneDeep(route);
      newRoute.time = Number(newRoute.time) / 60;
      newRoute.processingTime = Number(newRoute.processingTime) / 60;

      if (timeType === 'travellingTime') {
        return multiplier * newRoute.time;
      }

      if (timeType === 'processingTime') {
        var processingTime = newRoute.processingTime === 0 ? 15 : newRoute.processingTime;

        if (!this.isRealProcessingTime && route['status'].toUpperCase() === 'COMPLETED') {
          processingTime = this.defaultProcessingTime;
        }

        return multiplier * processingTime;
      }
    }
  }, {
    key: "getCurrentTimeLocation",
    value: function getCurrentTimeLocation() {
      var multiplier = this.ganttChartCellWidth / this.timeStepper;
      var start = (0, _moment.default)(new Date());
      var date = (0, _moment.default)(start).format('YYYY-MM-DD');
      var startTime = (0, _moment.default)(start).format('YYYY-MM-DD 00:00');
      var endTime = (0, _moment.default)(start);

      var duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();

      if (date !== this.$planDate) {
        var diff = (0, _moment.default)(date).diff((0, _moment.default)(this.$planDate), 'days');
        startTime = (0, _moment.default)(start).subtract(diff, 'days').format('YYYY-MM-DD 00:00');
        duration = _moment.default.duration(endTime.diff(startTime, 'minutes'), 'minutes').asMinutes();
      }

      this.currentTimeLeft = multiplier * duration;
    }
  }, {
    key: "getGCRowClass",
    value: function getGCRowClass(truck, truckIndex) {
      var _ref;

      var className = truck.id === this.$selectedTruck ? 'is-active' : this.isTruckIdExistInGlobal(truck.id) ? 'is-used' : 'is-disabled';
      return _ref = {}, (0, _defineProperty2.default)(_ref, className, true), (0, _defineProperty2.default)(_ref, 'bdr-btm-none', truckIndex === this.filteredTrucks.length - 1), (0, _defineProperty2.default)(_ref, 'cursor-pointer', this.isClickable && !this.checkDisable(truck.id) && !this.isTruckIdExistInGlobal(truck.id)), _ref;
    }
  }, {
    key: "getGCRowStyle",
    value: function getGCRowStyle(truck, truckIndex) {
      return {
        'width': this.truckWidth + 'px',
        'margin-top': truckIndex === 0 ? '1px' : '0'
      };
    }
  }, {
    key: "getDuration",
    value: function getDuration(route, type) {
      switch (type) {
        case 'processingTime':
        default:
          return !this.isRealProcessingTime && route.status.toUpperCase() === 'COMPLETED' ? this.helper.printThousandDecimal(this.defaultProcessingTime) : this.helper.printThousandDecimal(route.processingTime / 60);
      }
    }
  }, {
    key: "getTime",
    value: function getTime(route, type) {
      switch (type) {
        case 'startTime':
          return !this.isRealProcessingTime && route.status.toUpperCase() === 'COMPLETED' ? (0, _moment.default)(route.endTime).subtract(this.defaultProcessingTime + route.time / 60, 'minutes').format('YYYY-MM-DD HH:mm:ss') : route.startTime;

        case 'estimateTime':
        default:
          return !this.isRealProcessingTime && route.status.toUpperCase() === 'COMPLETED' ? (0, _moment.default)(route.endTime).subtract(this.defaultProcessingTime, 'minutes').format('YYYY-MM-DD HH:mm:ss') : route.estimateTime;
      }
    }
  }, {
    key: "getTranslation",
    value: function getTranslation(route, type) {
      switch (type) {
        case 'estimateTime':
          return route.status.toUpperCase() === 'COMPLETED' ? this.$t('planning.tooltip.arrivalTime') : this.$t('planning.tooltip.eta');

        case 'endTime':
        default:
          return route.status.toUpperCase() === 'COMPLETED' ? this.$t('planning.tooltip.end') : this.$t('planning.tooltip.expectedEnd');
      }
    }
  }]);
  return LMDGanttChartComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDeliveryPricerite.LastMileDeliveryMixin));

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 30
})], LMDGanttChartComponent.prototype, "defaultTimeStepper", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 54
})], LMDGanttChartComponent.prototype, "ganttChartCellWidth", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 600
})], LMDGanttChartComponent.prototype, "ganttChartHeight", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], LMDGanttChartComponent.prototype, "isAutoAssign", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], LMDGanttChartComponent.prototype, "isClickable", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], LMDGanttChartComponent.prototype, "isEnableAllTrucks", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 0
})], LMDGanttChartComponent.prototype, "initAutoAddedDays", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: null
})], LMDGanttChartComponent.prototype, "currentPlanId", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 1
})], LMDGanttChartComponent.prototype, "truckCurrentPage", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 10
})], LMDGanttChartComponent.prototype, "truckPageSize", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isFilterTruck')], LMDGanttChartComponent.prototype, "onIsFilterTruckChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isShowEnabledTruck')], LMDGanttChartComponent.prototype, "onIsShowEnabledTruckChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('initAutoAddedDays')], LMDGanttChartComponent.prototype, "onInitAutoAddedDaysChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$planDate')], LMDGanttChartComponent.prototype, "onPlanDateChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckFilters', {
  deep: true
})], LMDGanttChartComponent.prototype, "onTruckFiltersChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('defaultTimeStepper')], LMDGanttChartComponent.prototype, "onTimeStepperChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('isEnableAllTrucks')], LMDGanttChartComponent.prototype, "onBooleanEnableTrucksChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$plan.trucks')], LMDGanttChartComponent.prototype, "onTrucksChanges", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('$truckLoading')], LMDGanttChartComponent.prototype, "onTruckLoadingChanges", null);
LMDGanttChartComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDGanttChartComponent',
  components: {
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip,
    'el-dialog': _elementUi.Dialog,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button,
    'transfer-order-modal': _transferOrderModal.default
  }
})], LMDGanttChartComponent);
var _default = LMDGanttChartComponent;
exports.default = _default;